import { get } from '../..';

interface GetGuardTourDataProps {
  externalId: string,
}

const GetGuardTourData = ({
  externalId,
}: GetGuardTourDataProps) => get(`metrics/guard-tour-data?floorExternalId=${externalId}`);

export default GetGuardTourData;
